/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LightAmbientFromJSON, LightAmbientToJSON, LightAndroidLightProbeFromJSON, LightAndroidLightProbeToJSON, LightDirectionalLightFromJSON, LightDirectionalLightToJSON, LightPointLightFromJSON, LightPointLightToJSON, } from './';
export function LightFromJSON(json) {
    return LightFromJSONTyped(json, false);
}
export function LightFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ambient': !exists(json, 'ambient') ? undefined : LightAmbientFromJSON(json['ambient']),
        'pointLight': !exists(json, 'point_light') ? undefined : LightPointLightFromJSON(json['point_light']),
        'androidLightProbe': !exists(json, 'android_light_probe') ? undefined : LightAndroidLightProbeFromJSON(json['android_light_probe']),
        'directionalLight': !exists(json, 'directional_light') ? undefined : LightDirectionalLightFromJSON(json['directional_light']),
    };
}
export function LightToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ambient': LightAmbientToJSON(value.ambient),
        'point_light': LightPointLightToJSON(value.pointLight),
        'android_light_probe': LightAndroidLightProbeToJSON(value.androidLightProbe),
        'directional_light': LightDirectionalLightToJSON(value.directionalLight),
    };
}
//# sourceMappingURL=Light.js.map